import { Helmet } from 'react-helmet';
import type { VoidFunctionComponent } from 'react';

import FallbackImage from '../components/generic/FallbackImage';
import Text from '../components/generic/Text';

import Box from './generics/Box';

import styles from './NotFound.module.less';

const NotFound: VoidFunctionComponent = () => (
  <div className={styles.main}>
    <Box>
      <Helmet>
        <title>Not Found</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <FallbackImage src="404-cat" alt="confused fossa cat">
        <Text.Heading>404! Sorry about that!</Text.Heading>
        <span className={styles.message}>This page doesn&apos;t seem to exist! Try again or <a href="https://fossa.com">head over to our main site</a> to learn more about SBOMs and FOSSA.</span>
      </FallbackImage>
    </Box>
  </div>
);

export default NotFound;
